<template>
  <div class="columns c-rsvp-config__options">
    <div
      v-for="item in items"
      :key="item.mode"
      class="column select-confirmation"
      :class="{ active: selected == item.mode }"
      @click="selectedCard(item.mode)"
    >
      <base-icon :name="item.icon" />
      <p>{{ item.title }}</p>
      <div class="description" v-html="item.desc"></div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    mode: {
      type: String,
      default: 'opened',
    },
  },

  data() {
    return {
      selected: '',
      items: [
        {
          mode: 'opened',
          icon: 'painel/rsvp-open-icon',
          title: 'Confirmação de presença aberta',
          desc: 'Seus convidados poderão confirmar presença livremente ao acessar o seu site. Nesta opção <b>vocês não precisam cadastrá-los.</b>',
        },
        {
          mode: 'closed',
          icon: 'painel/rsvp-close-icon',
          title: 'Confirmação de presença fechada',
          desc: 'Somente convidados cadastrados poderão confirmar presença. Nesta opção <b>vocês deverão cadastrá-los previamente.</b>',
        },
      ],
    }
  },

  created() {
    this.selected = this.mode
  },

  methods: {
    selectedCard(mode) {
      this.selected = mode
      this.$emit('selected', mode)
    },
  },
}
</script>
<style scoped lang="scss">
.c-rsvp-config__options {
  gap: 26px;
  margin: 56px 0 !important;
  @media (max-width: $tablet) {
    margin: 32px 0 !important;
    display: flex;
    flex-direction: column;
  }
  .select-confirmation {
    cursor: pointer;
    border-radius: 8px;
    border: 1px solid #d9e2eb;
    display: flex;
    padding: 24px;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 16px;
    @media (min-width: $tablet) {
      width: calc(50% - 12px);
    }
    svg {
      width: 24px;
      height: 24px;
    }
    p {
      color: $gray-7;
      font-size: 18px;
      font-weight: 700;
      .description {
        color: $neutral;
        font-size: 16px;
        font-weight: 400;
        line-height: 22px; /* 137.5% */
      }
    }
    &.active {
      background: $neutrallightest;
      box-shadow: 0px 10px 8px 0px rgba(93, 117, 141, 0.05);
      border: 1px solid neutrallight;
    }
    &:hover {
      box-shadow: 0px 10px 8px 0px rgba(93, 117, 141, 0.05);
    }
  }
}
</style>
